import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { V2DialogModule } from '@coin/shared/core/ui-storybook';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'coin-enlarge-image',
  templateUrl: './enlarge-image.component.html',
  styleUrls: ['./enlarge-image.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [V2DialogModule, TranslateModule]
})
export class EnlargeImageComponent {
  data = inject<{
    imageUrl: string;
  }>(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<EnlargeImageComponent>>(MatDialogRef);

  close(): void {
    this.dialogRef.close();
  }
}
